import React from 'react';
import ReactCountryFlag from 'react-country-flag';

const OurPresence = () => {
    const countries = [
        { name: 'Brazil', code: 'BR' },
        { name: 'Cambodia', code: 'KH' },
        { name: 'Denmark', code: 'DK' },
        { name: 'Egypt', code: 'EG' },
        { name: 'Mexico', code: 'MX' },
        { name: 'Tanzania', code: 'TZ' },
        { name: 'Bahamas', code: 'BS' },
        { name: 'Bosnia & Herzegovina', code: 'BA' },
        { name: 'Algeria', code: 'DZ' },
        { name: 'Nigeria', code: 'NG' },
        { name: 'Oman', code: 'OM' },
        { name: 'Vietnam', code: 'VN' },
        { name: 'United Kingdom', code: 'GB' },
        { name: 'China', code: 'CN' },
        { name: 'Pakistan', code: 'PK' },
        { name: 'South Sudan', code: 'SS' },
        { name: 'Turkey', code: 'TR' },
        { name: 'Greece', code: 'GR' },
        { name: 'Thailand', code: 'TH' },
        { name: 'Ethiopia', code: 'ET' },
        { name: 'Lebanon', code: 'LB' },
        { name: 'Sri Lanka', code: 'LK' },
        { name: 'UAE', code: 'AE' },
        { name: 'Uzbekistan', code: 'UZ' },
        { name: 'Jordan', code: 'JO' },
        { name: 'Poland', code: 'PL' },
        { name: 'Indonesia', code: 'ID' },
        { name: 'Morocco', code: 'MA' },
        { name: 'Germany', code: 'DE' },
        { name: 'Portugal', code: 'PT' },
        { name: 'Kenya', code: 'KE' },
        { name: 'Netherlands', code: 'NL' },
    ];

    return (
        <section className="our-presence w-100 py-3 bg-light">
            <div className="container-fluid px-3 px-md-5">
                <h2 className="fw-bold fs-4 text-center mb-4">Our Presence</h2>
                <div className="row">
                    <div className="col-12">
                        <div className="d-flex flex-wrap justify-content-center gap-3 gap-md-4">
                            {countries.map((country) => (
                                <div 
                                    key={country.code} 
                                    className="country-item d-flex flex-row gap-2 justify-content-center align-items-center text-center align-items-center"
                                    style={{ 
                                        minWidth: '100px',
                                        maxWidth: '120px',
                                        flex: '0 0 auto'
                                    }}
                                >
                                    <ReactCountryFlag
                                        countryCode={country.code}
                                        svg
                                        className="mb-2"
                                        style={{ 
                                            width: "32px",
                                            height: "24px",
                                            objectFit: 'contain'
                                        }}
                                    />
                                    <span 
                                        className="fw-normal"
                                        style={{ 
                                            fontSize: "0.9rem",
                                            lineHeight: "1.2"
                                        }}
                                    >
                                        {country.name}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default OurPresence;